'use strict';

var _ = require('underscore'),
    SmoothScrollMixin = require('./SmoothScrollMixin'),
    getScrollY = require('../utils/getScrollY');

var ASSUMED_LINE_HEIGHT = 40,
    ANIMATE_DURATION = 200;

function getScrollAnchors(viewportHeight, el, id) {
  var rect = el.getBoundingClientRect(),
      rectCenter = (rect.bottom - rect.top) / 2,
      type = el.getAttribute('data-scroll-anchor') || 'image',
      viewportMiddle = viewportHeight / 2,
      element;

  element = {
    id: id,
    type: type
  };

  if (rectCenter > viewportMiddle) {
    return [
      { el: element, shift: rect.top },
      { el: element, shift: rect.bottom - viewportHeight}
    ];
  } else {
    return { el: element, shift: (rect.top + rectCenter) - viewportMiddle };
  }
}

/**
 * Provides keydown and keyup handlers that, when invoked, will mimic browser
 * scrolling but the scroll will snap, when close enough, to the center of
 * the next (or previous) child with `data-scroll-anchor` attribute.
 *
 * You can optionally specify scroll anchor type (`text` or `image`) as the
 * value of `data-scroll-anchor` attribute. By default, `image` is assumed.
 * This changes how much content we are allowed to skip when snapping. We may
 * skip tall image's start and end, but we may not skip any part of the text.
 *
 * The calling code must explicitly subscribe to `keydown` and `keyup` events,
 * check `isSpaceKeyEvent` and call `handleSpaceKeyUp` and `handleSpaceKeyDown`
 * when appropriate. This allows the calling code to have more control over
 * what happens.
 */
var AnchorScrollMixin = {
  mixins: [SmoothScrollMixin],

  isSpaceKeyEvent: function (e) {
    return e.keyCode === 32;
  },

  isSpaceKeyHeld: function () {
    return this._isSpaceKeyHeld;
  },

  handleSpaceKeyUp: function () {
    this._isSpaceKeyHeld = false;
  },

  handleSpaceKeyDown: function (e) {
    if (e.target !== document.body) {
      return;
    }

    var shouldBailOut = this.isSpaceKeyHeld();
    if (shouldBailOut) {
      return;
    }

    this._isSpaceKeyHeld = true;

    var isForward = !e.shiftKey,
        candidateAnchorY = this._getCandidateAnchorY(isForward);

    if (_.isNumber(candidateAnchorY)) {
      e.preventDefault();
      this.animateScroll(candidateAnchorY, ANIMATE_DURATION);
      this._lastTargetY = candidateAnchorY;
    }
  },

  _getCandidateAnchorY: function (isForward) {
    var vh = window.innerHeight,
        scrollY = getScrollY(),
        lastTargetY = this.isAnimatingScroll() ? this._lastTargetY : scrollY,
        anchors = this._findScrollAnchors(vh),
        maxCrossSectionShift = vh * 1.5,
        maxInSectionShift = vh - ASSUMED_LINE_HEIGHT,
        minPhotoShift = vh / 3,
        minTextShift = ASSUMED_LINE_HEIGHT * 2,
        prevAnchor,
        anchor,
        shift;

    function getMinShift(anchor, prevAnchor) {
      return (prevAnchor && prevAnchor.el.type === 'text') ?
        minTextShift :
        minPhotoShift;
    }

    function getMaxShift(anchor, prevAnchor) {
      return (prevAnchor && prevAnchor.el.id === anchor.el.id) ?
      maxInSectionShift :
      maxCrossSectionShift;
    }

    anchor = _
    .chain(anchors)
    .each(anchor => { anchor.shift += lastTargetY - scrollY; })
    .sortBy(function (anchor) {
      return isForward ? anchor.shift : -anchor.shift;
    })
    .find(function (anchor) {
      var isNext = isForward ?
        anchor.shift > getMinShift(anchor, prevAnchor) :
        anchor.shift < -getMinShift(anchor, prevAnchor);

      if (!isNext) {
        prevAnchor = anchor;
      }

      return isNext;
    })
    .value();

    if (!anchor) {
      return;
    }

    shift = isForward ?
      Math.min(anchor.shift, getMaxShift(anchor, prevAnchor)) :
      Math.max(anchor.shift, -getMaxShift(anchor, prevAnchor));

    if (Math.abs(shift) > getMinShift(anchor, prevAnchor)) {
      return Math.round(lastTargetY + shift);
    }
  },

  _findScrollAnchors: function (viewportHeight) {
    var el = this.getDOMNode(),
        scrollAnchorEls = _.toArray(el.querySelectorAll('[data-scroll-anchor]'));

    return  _
    .chain(scrollAnchorEls)
    .map(_.partial(getScrollAnchors, viewportHeight))
    .flatten()
    .value();
  }
};

module.exports = AnchorScrollMixin;


/** WEBPACK FOOTER **
 ** ./mixins/AnchorScrollMixin.js
 **/